'use client';

import { cn } from '@/lib/utils';
import css from './footer.module.scss';
import type { ReactElement } from 'react';
import Logo from './components/logo';
import Status from './components/status';
import Social from './components/social';

const version = process.env.NEXT_PUBLIC_APP_VERSION;

export default function Footer(): ReactElement {
  return (
    <div className={cn(css.wrapper, 'bg-secondary/70')}>
      <footer className={cn(css.main, 'relative text-secondary-foreground gap-4 sm:gap-8')}>
        <div className="w-full flex justify-between items-center flex-col sm:flex-row gap-4">
          <Logo />
          <Social />
        </div>
        <div className="w-full flex flex-col gap-4 items-center justify-center">
          <div className="w-full flex flex-col items-center justify-center gap-3">
            <p className="w-full text-xs sm:text-sm font-light opacity-80 text-center">
              All rights reserved.
            </p>
            <div className="w-full text-xs font-light opacity-80 text-center flex items-center justify-center gap-1">
              <p>Version</p>
              <p className="tabular-nums">{version}</p>
            </div>
          </div>
          <Status />
        </div>
      </footer>
    </div>
  );
}
